import React, { useState, useEffect, useMemo, useRef } from 'react';
import { connect } from 'react-redux';
import {
	Box,
	Button,
	Grid,
	TextField,
	Typography,
	Paper,
	Tabs,
	Tab,
	FormControl,
	Select,
	MenuItem,
	Tooltip
} from '@mui/material';
import { StyledTable } from '../../components';
import { useResolutionScale } from '../../hooks';
import { useMessageContextManager } from '../../components/MessageOverlay/MessageOverlay';
import {
	wtclOverride,
	completeWTCL,
	massistCallForDefectCheck,
	fetchSapVinStatus,
} from '../../redux/actionCreators/defect';
import {
	fetchQualityDefectDetails,
	closeDefect,
	fetchEngineSerialNumber,
} from '../../redux/actionCreators/qualityDefect';
import { getFeatures } from '../../redux/actionCreators/processValidation';
import { receivePart } from '../../redux/actionCreators/receivePart';
import { useRedirectToNextScreen } from '../../hooks';
import {
	OPERATIONS,
	REDIRECT_URLS,
	DARK_MODE,
	ZPL_TEMPLATE_FOR_WTCL_PRINT,
	isPuneJlr,
	ZPL_TEMPLATE_FOR_WTCL_PRINT_PUNE_JLR,
	getOkTagMonthYear,
} from '../../constants';
// eslint-disable-next-line no-unused-vars
import RefreshIcon from '@mui/icons-material/Refresh';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import TableActionBar, {
	GradientButton,
} from '../../components/TableActionBar/TableActionBar';
import ExceptionPopup from '../../components/Exception/ExceptionPopup';
import TakeOut from '../../components/TakeOut/TakeOut';
import MoveToMr from '../../components/MoveToMr/MoveToMr';
import DefectModal from '../../components/ReportModal/DefectModal';
import CloseDefectModal from '../../components/ReportModal/CloseDefectModal';
import ModalDialog from '../../components/ModalDialog/ModalDialog';
import { encryptStationPassword } from '../../utils/EncryptionUtils';
import styles from './WTCL.module.scss';

// TODO: Move to environment variables after testing
const WTCL_AUTO_CREDENTIALS = {
	username: 'kailas.c',
	password: '$2b$10$G5nq2BxvJf4yT0qQ9wvhL.I8mw7Kef9UtRXd941G5mpRrAevLZOJa',
	remark: 'Auto-approved by system',
};

const mapStateToProps = (state) => ({
	currentLineItem: state.station.currentLineItem,
	partValidation: state.partValidation,
	receivePart: state.receivePart,
	themeMode: state.theme.themeMode,
	allowedOperations: state.operations.allowedOperations,
	user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
	fetchQualityDefectDetails: (vin, success, error) =>
		dispatch(fetchQualityDefectDetails(vin, success, error)),
	closeDefect: (defectIds, success, error) =>
		dispatch(closeDefect(defectIds, success, error)),
	fetchEngineSerialNumber: (vin, success, error) =>
		dispatch(fetchEngineSerialNumber(vin, success, error)),
	massistCallForDefectCheck: (vin, success, error) =>
		dispatch(massistCallForDefectCheck(vin, success, error)),
	fetchSapVinStatus: (vin, success, error) =>
		dispatch(fetchSapVinStatus(vin, success, error)),
	wtclOverride: (seq, payload, success, error) =>
		dispatch(wtclOverride(seq, payload, success, error)),
	completeWTCL: (seq, success, error) =>
		dispatch(completeWTCL(seq, success, error)),
	getFeatures: (success, error) => dispatch(getFeatures(success, error)),
});

const WTCL = ({
	currentLineItem,
	partValidation,
	receivePart,
	themeMode,
	// eslint-disable-next-line no-unused-vars
	allowedOperations,
	fetchQualityDefectDetails,
	wtclOverride,
	completeWTCL,
	closeDefect,
	fetchEngineSerialNumber,
	massistCallForDefectCheck,
	fetchSapVinStatus,
	getFeatures,
	user,
}) => {
	// eslint-disable-next-line no-unused-vars
	const { scaleValue, getResponsiveValue } = useResolutionScale();
	const { showMessageOverlay } = useMessageContextManager();
	const redirect = useRedirectToNextScreen();

	const [manualOpenDefects, setManualOpenDefects] = useState([]);
	const [manualClosedDefects, setManualClosedDefects] = useState([]);
	const [autoOpenDefects, setAutoOpenDefects] = useState([]);
	const [autoClosedDefects, setAutoClosedDefects] = useState([]);
	const [activeDefectTab, setActiveDefectTab] = useState('manual');
	const [statusFilter, setStatusFilter] = useState('ALL');
	const [hasOpenDefects, setHasOpenDefects] = useState(false);
	const [selectedDefectIds, setSelectedDefectIds] = useState([]);
	// eslint-disable-next-line no-unused-vars
	const [loading, setLoading] = useState(false);

	const [isDisplayOverallParamsFalse, setIsDisplayOverallParamsFalse] = useState(false);
	const [isMassist, setIsMassist] = useState(false);
	const [showAuthModal, setShowAuthModal] = useState(false);
	const [authModalNotice, setAuthModalNotice] = useState(null);
	const [isDefectModalOpen, setIsDefectModalOpen] = useState(false);
	const [isCloseDefectModalOpen, setIsCloseDefectModalOpen] = useState(false);
	const [closingDefects, setClosingDefects] = useState(false);
	const [showWTCLPrintModal, setShowWTCLPrintModal] = useState(false);
	const [isEngineReadonly, setIsEngineReadonly] = useState(false);
	const [showPrintPreview, setShowPrintPreview] = useState(false);
	const [isWtclOverrideDone, setIsWtclOverrideDone] = useState(false);
	const isFromModal = useRef(false);
	const [previewZplEncoded, setPreviewZplEncoded] = useState('');
	const [printModalInfo, setPrintModalInfo] = useState('');
	const [wtclCheckStatus, setWtclCheckStatus] = useState({
		active: false,
		text: '',
		isError: false,
	});
	const [wtclPrintForm, setWtclPrintForm] = useState({
		vin: '',
		engineSerialNumber: '',
		model: '',
		colour: '',
		kspec: '',
		description: '',
		partNumber: '',
		monthYear: '',
	});

	const serialNumber =
		partValidation.serialNumber ||
		receivePart.serialNumber ||
		currentLineItem?.serialNumber;

	useEffect(() => {
		getFeatures(
			(data) => {
				const flag = data?.find((f) => f.name === 'DISPLAY_OVERALL_PARAMS');
				setIsDisplayOverallParamsFalse(flag?.enabled === false);

				const massistFlag = data?.find((f) => f.name === 'MASSIST');
				setIsMassist(Boolean(massistFlag?.enabled));
			},
			() => {
				setIsDisplayOverallParamsFalse(false);
			},
		);
	}, [getFeatures]);

const normalizeDefectRow = (d, status, defectCategory) => {
	const rawId = d?.mesDefectId ?? d?.defectId ?? d?.id;

	if (rawId === undefined || rawId === null) return null;

	const id = Number(rawId);
	if (Number.isNaN(id)) return null;

	const defectOpenedTs =
		d?.mesDefectTs ?? d?.defectOpenedTs ?? d?.openedTs ?? null;

	const stationUser = d?.createdBy ?? '';
	const checkedBy = d?.mesCheckedByUser ?? d?.defectRaisedBy ?? '';

	const defectTypeLabel = defectCategory === 'MANUAL' ? 'Manual' : 'Auto';

	const parameterKey =
		d?.machineDefect?.parameterKey ?? d?.partDefect?.parameterKey ?? '-';

	return {
		...d, // Preserve all original API fields
		id,
		defectOpenedTs,

		// Separate fields for Manual defects
		skipReason: d?.mesSkipReason ?? d?.skipReason ?? '-',
		skipRemark: d?.mesSkipRemark ?? d?.skipRemark ?? '-',
		closeReason: d?.mesCloseReason ?? d?.closeReason ?? '-',
		closeRemark: d?.mesCloseRemark ?? d?.closeRemark ?? '-',

		// Preserve the existing Auto defect fields.
		// Do not overwrite reason or remark.
		stationUser: stationUser || '-',
		checkedBy: checkedBy || '-',
		parameterKey: parameterKey || '-',
		defectType: defectTypeLabel,
		defectStatus: status,
		isManual: defectCategory === 'MANUAL',
	};
};

	const normalizeDefectList = (list, status, defectCategory) =>
		(list || [])
			.map((d) => normalizeDefectRow(d, status, defectCategory))
			.filter(Boolean);

	const fetchDefects = () => {
		if (!serialNumber) return;
		setLoading(true);

		fetchQualityDefectDetails(
			serialNumber,
			(data) => {
				const manualOpen = normalizeDefectList(
					data?.open?.manualDefects,
					'OPEN',
					'MANUAL',
				);
				const manualClosed = normalizeDefectList(
					data?.closed?.manualDefects,
					'CLOSED',
					'MANUAL',
				);

				const autoOpen = [
					...normalizeDefectList(data?.open?.partDefects, 'OPEN', 'AUTO'),
					...normalizeDefectList(data?.open?.machineDefects, 'OPEN', 'AUTO'),
				];
				const autoClosed = [
					...normalizeDefectList(data?.closed?.partDefects, 'CLOSED', 'AUTO'),
					...normalizeDefectList(
						data?.closed?.machineDefects,
						'CLOSED',
						'AUTO',
					),
				];

				setManualOpenDefects(manualOpen);
				setManualClosedDefects(manualClosed);
				setAutoOpenDefects(autoOpen);
				setAutoClosedDefects(autoClosed);

				setHasOpenDefects(manualOpen.length + autoOpen.length > 0);
				setSelectedDefectIds([]);
				setLoading(false);
			},
			(err) => {
				console.error('Error fetching defects:', err);
				showMessageOverlay({
					contextText: 'Fetch Failed',
					info: err?.response?.data?.message || 'Failed to load defects',
					error: true,
				});
				setLoading(false);
			},
		);
	};

	useEffect(() => {
		if (serialNumber) {
			fetchDefects();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [serialNumber]);

	const handleTabChange = (_event, newValue) => {
		setActiveDefectTab(newValue);
		setSelectedDefectIds([]);
		setStatusFilter('ALL');
	};

	const handleStatusFilterChange = (event) => {
		setStatusFilter(event.target.value);
		setSelectedDefectIds([]);
	};

	const handleCloseDefect = () => {
		if (selectedDefectIds.length === 0) {
			showMessageOverlay({
				contextText: 'No Defects Selected',
				info: 'Please select at least one open defect to close.',
				error: true,
			});
			return;
		}
		setIsCloseDefectModalOpen(true);
	};

	const handleSubmitCloseDefects = ({ reason, remarks }) => {
		if (!reason?.trim()) {
			showMessageOverlay({
				contextText: 'Reason Required',
				info: 'Please enter a reason to close defect(s).',
				error: true,
			});
			return;
		}
		if (selectedDefectIds.length === 0) {
			showMessageOverlay({
				contextText: 'No Defects Selected',
				info: 'Please select at least one open defect to close.',
				error: true,
			});
			return;
		}

		if (activeDefectTab === 'auto' && !serialNumber) {
			showMessageOverlay({
				contextText: 'Serial Number Required',
				info: 'A serial number is required to close auto defects.',
				error: true,
			});
			return;
		}

		setClosingDefects(true);
		const closeOverlay = showMessageOverlay({
			contextText: 'Closing Defects...',
			loading: true,
		});

		const payload = selectedDefectIds.map((defectId) => ({
			defectId,
			closeReason: reason.trim(),
			closeRemark: (remarks || '').trim(),
			closedBy: user?.username || user?.name || '',
		}));

		const runCloseDefect = () => {
			try {
				closeDefect(
					payload,
					(res) => {
						setClosingDefects(false);
						setIsCloseDefectModalOpen(false);
						closeOverlay();
						showMessageOverlay({
							contextText: 'Success',
							info: res?.message || 'Defects closed successfully',
							success: true,
						});
						setSelectedDefectIds([]);
						fetchDefects();
					},
					(err) => {
						setClosingDefects(false);
						closeOverlay();
						showMessageOverlay({
							contextText: 'Close Defect Failed',
							info: err?.response?.data?.message || 'An error occurred',
							error: true,
						});
					},
				);
			} catch (err) {
				showMessageOverlay({
					contextText: 'Error while closing defect',
					info: err || 'An error occurred',
					error: true,
				});
			}
		};

		if (activeDefectTab === 'auto') {
			if (!isPuneJlr() && isMassist) {
				massistCallForDefectCheck(
					serialNumber,
					() => runCloseDefect(),
					(err) => {
						const massistStatus = err?.response?.data?.status;
						const allowCloseStatuses = [
							'VIN_NOT_FOUND',
							'MASSIST_INTERNAL_ERROR',
							'MASSIST_DEFECT_API_RETRY_FAILURE',
							'Massist is not enabled',
						];

						if (allowCloseStatuses.includes(massistStatus)) {
							runCloseDefect();
							return;
						}

						setClosingDefects(false);
						closeOverlay();
						showMessageOverlay({
							contextText: 'MAssist Check Failed',
							info:
								err?.response?.data?.message ||
								'Could not complete defect check before closing.',
							error: true,
						});
					},
				);
			} else{
				runCloseDefect();
			}
		} else {
			runCloseDefect();
		}
	};

	const handleAutoAuthSubmit = () => {
		const closeOverlay = showMessageOverlay({
			contextText: 'Processing WTCL Override...',
			loading: true,
		});

		const payload = {
			username: WTCL_AUTO_CREDENTIALS.username,
			password: WTCL_AUTO_CREDENTIALS.password,
			action: 'WTCL_DEFECT_OVERRIDE',
			remark: WTCL_AUTO_CREDENTIALS.remark,
		};

		wtclOverride(
			currentLineItem?.sequenceNumber,
			payload,
			() => {
				closeOverlay();
				setIsWtclOverrideDone(true);
				if (isFromModal.current) {
					handleRedirectOnSuccess();
				} else {
					handleFinalWTCL();
				}
			},
			(err) => {
				closeOverlay();
				showMessageOverlay({
					contextText: 'Authentication Failed',
					info: err?.response?.data?.message || 'Unauthorized',
					error: true,
				});
			},
		);
	};

	const handleAuthSubmit = (userData) => {
		const closeOverlay = showMessageOverlay({
			contextText: 'Authenticating Override...',
			loading: true,
		});

		const payload = {
			username: userData.username,
			password: encryptStationPassword(userData.password),
			action: 'WTCL_DEFECT_OVERRIDE',
			remark: userData.remark,
		};

		wtclOverride(
			currentLineItem?.sequenceNumber,
			payload,
			() => {
				closeOverlay();
				setIsWtclOverrideDone(true);
				setShowAuthModal(false);
				if (isFromModal.current) {
					handleRedirectOnSuccess();
				} else {
					handleFinalWTCL();
				}
			},
			(err) => {
				closeOverlay();
				showMessageOverlay({
					contextText: 'Authentication Failed',
					info: err?.response?.data?.message || 'Unauthorized',
					error: true,
				});
			},
		);
	};

	const trimColourForPune = (colourStr) => {
		if (!colourStr) return '';
		if (!isPuneJlr()) return colourStr;
		const baseColour = colourStr.split('_')[0].trim();
		const words = baseColour.split(/\s+/);
		return words.slice(0, 2).join(' ');
	};

	const getMonthYearFromCrtdDate = (crtdDateStr) => {
		if (!crtdDateStr) return '';
		try {
			// Handle "YYYY-MM-DD" or "YYYY-MM-DDTHH:mm:ss" directly to avoid Timezone shift issues
			if (typeof crtdDateStr === 'string' && crtdDateStr.includes('-')) {
				const dateParts = crtdDateStr.split('T')[0].split('-');
				if (dateParts.length >= 2) {
					const year = dateParts[0].slice(-2);
					const month = dateParts[1].padStart(2, '0');
					return `${month}/${year}`;
				}
			}

			// Fallback for other timestamp formats
			const date = new Date(crtdDateStr);
			if (isNaN(date.getTime())) return '';
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const year = String(date.getFullYear()).slice(-2);
			return `${month}/${year}`;
		} catch (e) {
			return '';
		}
	};

	const openWTCLPrintModal = ({
		engineSerialNumber = '',
		model = '',
		colour = '',
		engineReadonly = false,
		info = '',
		vin = '',
		kspec = '',
		description = '',
		partNumber = '',
		monthYear = '',
	}) => {
		const resolvedVin = vin || serialNumber || '';
		const resolvedMonthYear = monthYear || new Date().toLocaleDateString('en-GB', {
			month: '2-digit',
			year: '2-digit',
		});
		setWtclPrintForm({
			vin: resolvedVin,
			engineSerialNumber,
			model,
			colour: trimColourForPune(colour),
			kspec,
			description,
			partNumber,
			monthYear: getOkTagMonthYear(resolvedMonthYear, resolvedVin),
		});
		setIsEngineReadonly(engineReadonly);
		setPrintModalInfo(info);
		setShowWTCLPrintModal(true);
	};

	const handleFinalWTCL = () => {
		const closeOverlay = showMessageOverlay({
			contextText: 'Finalizing WTCL...',
			loading: true,
		});

		const defaultModel =
			currentLineItem?.model ||
			currentLineItem?.modelCode ||
			currentLineItem?.vehicleModel ||
			'';
		const defaultColour =
			currentLineItem?.colour ||
			currentLineItem?.color ||
			currentLineItem?.vehicleColor ||
			'';
		const defaultKspec =
			currentLineItem?.partNumber ||
			currentLineItem?.vcPartNumber ||
			'';
		const defaultDescription =
			currentLineItem?.description ||
			currentLineItem?.vcDescription ||
			'';

		fetchEngineSerialNumber(
			serialNumber,
			(engineData) => {
				const printData = {
					vin: engineData?.serialNumber || serialNumber || '',
					engineSerialNumber: engineData?.engineSerialNumber || '',
					// WTCL "Model" comes from the VIN/KSPEC attributes `description`.
					model:
						engineData?.description ||
						defaultModel ||
						engineData?.model ||
						engineData?.modelCode ||
						engineData?.vehicleModel ||
						'',
					colour:
						engineData?.colour ||
						defaultColour ||
						engineData?.color ||
						engineData?.vehicleColor ||
						'',
					kspec: engineData?.kspec || defaultKspec,
					description: engineData?.description || defaultDescription,
					// "PART_NUMBER" placeholder in ZPL uses whatever we have (often KSPEC).
					partNumber:
						engineData?.partNumber ||
						engineData?.vcPartNumber ||
						engineData?.kspec ||
						defaultKspec,
					monthYear: getMonthYearFromCrtdDate(engineData?.ipmsDate),
				};
				closeOverlay();
				openWTCLPrintModal({
					...printData,
					engineReadonly: true,
					info: 'WTCL completed. Click Print to print OK tag. Use Retry Print if needed.',
				});
			},
			(err) => {
				closeOverlay();
				openWTCLPrintModal({
					vin: serialNumber || '',
					engineSerialNumber: '',
					model: defaultModel,
					colour: defaultColour,
					kspec: defaultKspec,
					description: defaultDescription,
					partNumber: defaultKspec,
					engineReadonly: false,
					info:
						err?.response?.data?.message ||
						'VIN/KSPEC attributes fetch failed. Enter/scan details, then click Print.',
				});
			},
		);
	};

	const handleFinalWTCLFromModal = () => {
		const closeOverlay = showMessageOverlay({
			contextText: 'Finalizing WTCL...',
			loading: true,
		});

		completeWTCL(
			currentLineItem?.sequenceNumber,
			() => {
				closeOverlay();
				handleRedirectOnSuccess();
			},
			(err) => {
				closeOverlay();
				isFromModal.current = false;
				showMessageOverlay({
					contextText: 'WTCL Completion Failed',
					info: err?.response?.data?.message || 'An error occurred',
					error: true,
				});
			},
		);
	};

	const handleRedirectOnSuccess = () => {
		isFromModal.current = false;
		setShowWTCLPrintModal(false);
		setShowPrintPreview(false);
		showMessageOverlay({
			contextText: 'WTCL Complete',
			info: 'WTCL completed successfully.',
			success: true,
		});
		redirectToHomeScreen();
	}

	const redirectToHomeScreen = () =>
		redirect(null, {
			operation: OPERATIONS.RECEIVE_PART,
			redirectUrl: REDIRECT_URLS[OPERATIONS.RECEIVE_PART],
		});

	const handlePrintFieldChange = (field, value) => {
		setWtclPrintForm((prev) => ({
			...prev,
			[field]: value,
		}));
	};

	const handlePrintFromModal = () => {
		if (!wtclPrintForm.engineSerialNumber?.trim()) {
			showMessageOverlay({
				contextText: 'Engine Serial Number Required',
				info: 'Please enter engine serial number to print OK tag.',
				error: true,
			});
			return;
		}
		if (!wtclPrintForm.model?.trim()) {
			showMessageOverlay({
				contextText: 'Model Required',
				info: 'Please enter model to print OK tag.',
				error: true,
			});
			return;
		}
		if (!wtclPrintForm.colour?.trim()) {
			showMessageOverlay({
				contextText: 'Colour Required',
				info: 'Please enter colour to print OK tag.',
				error: true,
			});
			return;
		}

		const isPune = isPuneJlr();
		const template = isPune
			? ZPL_TEMPLATE_FOR_WTCL_PRINT_PUNE_JLR
			: ZPL_TEMPLATE_FOR_WTCL_PRINT;

		const wtclZpl = template
			.replace(/{VIN}/g, wtclPrintForm.vin || '')
			.replace(/{ENGINE_NUMBER}/g, wtclPrintForm.engineSerialNumber.trim())
			.replace(/{MODEL}/g, wtclPrintForm.model.trim())
			.replace(/{COLOUR}/g, wtclPrintForm.colour.trim())
			.replace(/{COLOR}/g, wtclPrintForm.colour.trim())
			.replace(/{KSPEC}/g, wtclPrintForm.kspec || '')
			.replace(/{DESCRIPTION}/g, wtclPrintForm.description || '')
			.replace(/{PART_NUMBER}/g, wtclPrintForm.partNumber || '')
			.replace(/{MONTH_YEAR}/g, wtclPrintForm.monthYear || new Date().toLocaleDateString('en-GB', {
				month: '2-digit',
				year: '2-digit',
			}))
			.replace(/{DATE}/g, new Date().toLocaleDateString());

		const wtclZplEncoded = encodeURIComponent(wtclZpl);

		// Show preview instead of printing directly
		setPreviewZplEncoded(wtclZplEncoded);
		setShowPrintPreview(true);
	};

	const performActualPrint = () => {
		window.location.href = `nirmaan://?cmd=print&zplstring=${previewZplEncoded}`;
		showMessageOverlay({
			contextText: 'Printing OK Tag...',
			info: 'Print command sent. Click Mark WTCL to complete the process.',
			success: true,
		});
		setShowPrintPreview(false);
		if (isWtclOverrideDone) {
			handleRedirectOnSuccess()
		} else {
			handleFinalWTCLFromModal()
		}
		// handleMarkWTCLFromModal();
	};

	const parseMassistCheckBody = (data) => {
		if (!data || typeof data !== 'object') return null;
		return {
			status: data.status,
			message: typeof data.message === 'string' ? data.message : '',
			canOverride: data.canOverride === true,
		};
	};

	const parseSapVinStatusBody = (data) => {
		if (!data || typeof data !== 'object') return null;
		return {
			status: data.status,
			statusDescription:
				typeof data.statusDescription === 'string' ? data.statusDescription : '',
			canDoWtcl: data.canDoWtcl === true,
			errorMessage:
				typeof data.errorMessage === 'string' ? data.errorMessage : '',
		};
	};

	const updateWtclCheckStatus = (text, isError = false) => {
		setWtclCheckStatus({
			active: true,
			text,
			isError,
		});
	};

	const handleMarkWTCLClick = () => {
		if (!serialNumber) {
			showMessageOverlay({
				contextText: 'Serial Number Required',
				info: 'A serial number is required to proceed.',
				error: true,
			});
			return;
		}

		const closeOverlay = showMessageOverlay({
			contextText: 'Fetching VIN Details...',
			loading: true,
		});

		const defaultModel =
			currentLineItem?.model ||
			currentLineItem?.modelCode ||
			currentLineItem?.vehicleModel ||
			'';
		const defaultColour =
			currentLineItem?.colour ||
			currentLineItem?.color ||
			currentLineItem?.vehicleColor ||
			'';
		const defaultKspec =
			currentLineItem?.partNumber ||
			currentLineItem?.vcPartNumber ||
			'';
		const defaultDescription =
			currentLineItem?.description ||
			currentLineItem?.vcDescription ||
			'';

		fetchEngineSerialNumber(
			serialNumber,
			(engineData) => {
				const printData = {
					vin: engineData?.serialNumber || serialNumber || '',
					engineSerialNumber: engineData?.engineSerialNumber || '',
					model:
						engineData?.description ||
						defaultModel ||
						engineData?.model ||
						engineData?.modelCode ||
						engineData?.vehicleModel ||
						'',
					colour:
						engineData?.colour ||
						defaultColour ||
						engineData?.color ||
						engineData?.vehicleColor ||
						'',
					kspec: engineData?.kspec || defaultKspec,
					description: engineData?.description || defaultDescription,
					partNumber:
						engineData?.partNumber ||
						engineData?.vcPartNumber ||
						engineData?.kspec ||
						defaultKspec,
					monthYear: getMonthYearFromCrtdDate(engineData?.ipmsDate),
				};
				closeOverlay();
				openWTCLPrintModal({
					...printData,
					engineReadonly: true,
					info: 'Review details and print the OK tag, then click Mark WTCL to complete.',
				});
			},
			(err) => {
				closeOverlay();
				openWTCLPrintModal({
					vin: serialNumber || '',
					engineSerialNumber: '',
					model: defaultModel,
					colour: defaultColour,
					kspec: defaultKspec,
					description: defaultDescription,
					partNumber: defaultKspec,
					engineReadonly: false,
					info:
						err?.response?.data?.message ||
						'Enter details below, print the OK tag, then click Mark WTCL.',
				});
			},
		);
	};

	const handleMarkWTCLFromModal = () => {
		if (!serialNumber) {
			showMessageOverlay({
				contextText: 'Serial Number Required',
				info: 'A serial number is required to verify before marking WTCL.',
				error: true,
			});
			return;
		}

		isFromModal.current = true;
		updateWtclCheckStatus('QA hold checking in SAP...');
		const closeOverlay = showMessageOverlay({
			contextText: 'Checking SAP VIN Status...',
			loading: true,
		});

		const runMassistCheck = (onCloseOverlay) => {
			massistCallForDefectCheck(
				serialNumber,
				(data) => {
					onCloseOverlay();
					const parsed = parseMassistCheckBody(data);
					if (!parsed) {
						updateWtclCheckStatus('MAssist check failed.', true);
						showMessageOverlay({
							contextText: 'Massist Check Failed',
							info: 'Invalid response from server.',
							error: true,
						});
						return;
					}
					if (parsed.status === 'NO_OPEN_DEFECTS') {
						updateWtclCheckStatus('All checks passed. Completing WTCL...');
						handleFinalWTCLFromModal();
						return;
					}
					if (parsed.canOverride) {
						updateWtclCheckStatus('MAssist needs override approval to continue.', true);
						if (isDisplayOverallParamsFalse) {
							handleAutoAuthSubmit();
						} else {
							setAuthModalNotice(
								parsed.message || 'Privileged approval is required to proceed.',
							);
							setShowAuthModal(true);
						}
						return;
					}
					updateWtclCheckStatus('MAssist blocked WTCL.', true);
					showMessageOverlay({
						contextText: 'Cannot Mark WTCL',
						info:
							parsed.message ||
							'Resolve Massist defects before marking WTCL, or use an authorized override.',
						error: true,
					});
				},
				(err) => {
					onCloseOverlay();
					const resData = err?.response?.data;
					const parsed = parseMassistCheckBody(resData);

					const massistBypassStatuses = [
						'VIN_NOT_FOUND',
						'MASSIST_INTERNAL_ERROR',
						'MASSIST_DEFECT_API_RETRY_FAILURE',
						'Massist is not enabled',
					];
					if (massistBypassStatuses.includes(resData?.message)) {
						updateWtclCheckStatus('All checks passed. Completing WTCL...');
						handleFinalWTCLFromModal();
						return;
					}

					if (parsed?.canOverride) {
						updateWtclCheckStatus('MAssist needs override approval to continue.', true);
						if (isDisplayOverallParamsFalse) {
							handleAutoAuthSubmit();
						} else {
							setAuthModalNotice(
								parsed.message || 'Privileged approval is required to proceed.',
							);
							setShowAuthModal(true);
						}
						return;
					}
					updateWtclCheckStatus('MAssist check failed.', true);
					showMessageOverlay({
						contextText: 'Massist Check Failed',
						info:
							parsed?.message ||
							resData?.message ||
							err?.message ||
							'An error occurred',
						error: true,
					});
				},
			);
		};

		fetchSapVinStatus(
			serialNumber,
			() => {
				runMassistCheck(closeOverlay);
			},
			() => {
				runMassistCheck(closeOverlay);
			},
		);
	};

	const partDetailsColumns = [
		{
			title: 'Scanned Serial No./VIN',
			field: 'serialNumber',
			width: 300,
			render: (row) => (
				<Typography sx={{ fontWeight: 'bold', textAlign: 'center' }}>
					{row.serialNumber}
				</Typography>
			),
		},
		{
			title: 'KSPEC',
			field: 'partNumber',
			width: 250,
			render: (row) => (
				<Typography sx={{ fontWeight: 'bold', textAlign: 'center' }}>
					{row.partNumber}
				</Typography>
			),
		},
		{
			title: isPuneJlr() ? 'Model' : 'KSPEC Description',
			field: isPuneJlr() ? 'model' : 'description',
			width: 450,
			render: (row) => (
				<Typography sx={{ fontWeight: 'bold', textAlign: 'center' }}>
					{isPuneJlr() ? (currentLineItem?.model || row.description) : row.description}
				</Typography>
			),
		},
		{
			title: 'Lot Number',
			field: 'lotNumber',
			width: 250,
			render: (row) => (
				<Typography sx={{ fontWeight: 'bold', textAlign: 'center' }}>
					{currentLineItem?.lotNumber || row.lotNumber}
				</Typography>
			),
		},
	];

	const partDetailsData = [
		{
			serialNumber: serialNumber || '-',
			partNumber:
				currentLineItem?.partNumber || currentLineItem?.vcPartNumber || '-',
			description:
				currentLineItem?.description || currentLineItem?.vcDescription || '-',
			lotNumber:
				currentLineItem?.lotNumber || '-',
		},
	];

	const manualDefectColumns = [
		{ title: 'ID', field: 'id', align: 'center', width: 100 },
		{ title: 'Type', field: 'defectType', align: 'center', width: 150 },
		// {
		// 			title: 'Defect reason',
		// 			field: 'reason',
		// 			align: 'center',
		// 			width: 250,
		// 			render: (row) => (
		// 				<Typography
		// 						sx={{
		// 								display: '-webkit-box',
		// 								WebkitBoxOrient: 'vertical',
		// 								WebkitLineClamp: 3,
		// 								overflow: 'hidden',
		// 								whiteSpace: 'normal',
		// 								overflowWrap: 'break-word',
		// 								wordBreak: 'break-word',
		// 								lineHeight: 1.4,
		// 						}}
		// 				>
		// 						{row.reason}
		// 				</Typography>
		// 			),
		// 		},
		// { title: 'Remark', field: 'remark', align: 'center', width: 300 },
		{
					title: 'Open Reason',
					field: 'skipReason',
					align: 'center',
					width: 220,
					render: (row) => (
						<Typography
							sx={{
								display: '-webkit-box',
								WebkitBoxOrient: 'vertical',
								WebkitLineClamp: 3,
								overflow: 'hidden',
								whiteSpace: 'normal',
								overflowWrap: 'break-word',
								wordBreak: 'break-word',
								lineHeight: 1.4,
							}}
						>
							{row.skipReason}
						</Typography>
					),
				},
				{
					title: 'Open Remark',
					field: 'skipRemark',
					align: 'center',
					width: 250,
					render: (row) => (
						<Typography
							sx={{
								display: '-webkit-box',
								WebkitBoxOrient: 'vertical',
								WebkitLineClamp: 3,
								overflow: 'hidden',
								whiteSpace: 'normal',
								overflowWrap: 'break-word',
								wordBreak: 'break-word',
								lineHeight: 1.4,
							}}
						>
							{row.skipRemark}
						</Typography>
					),
				},
				{
					title: 'Close Reason',
					field: 'closeReason',
					align: 'center',
					width: 220,
					render: (row) => (
						<Typography
							sx={{
								display: '-webkit-box',
								WebkitBoxOrient: 'vertical',
								WebkitLineClamp: 3,
								overflow: 'hidden',
								whiteSpace: 'normal',
								overflowWrap: 'break-word',
								wordBreak: 'break-word',
								lineHeight: 1.4,
							}}
						>
							{row.closeReason}
						</Typography>
					),
				},
				{
					title: 'Close Remark',
					field: 'closeRemark',
					align: 'center',
					width: 250,
					render: (row) => (
						<Typography
							sx={{
								display: '-webkit-box',
								WebkitBoxOrient: 'vertical',
								WebkitLineClamp: 3,
								overflow: 'hidden',
								whiteSpace: 'normal',
								overflowWrap: 'break-word',
								wordBreak: 'break-word',
								lineHeight: 1.4,
							}}
						>
							{row.closeRemark}
						</Typography>
					),
		},
		{
			title: 'Status',
			field: 'defectStatus',
			align: 'center',
			width: 150,
			render: (row) => (
				<Box
					sx={{
						background:
							row.defectStatus === 'CLOSED'
								? 'rgba(76, 175, 80, 0.1)'
								: 'rgba(244, 67, 54, 0.1)',
						color: row.defectStatus === 'CLOSED' ? '#4CAF50' : '#F44336',
						px: 2,
						py: 0.5,
						borderRadius: '20px',
						display: 'inline-block',
						fontWeight: 'bold',
					}}
				>
					{row.defectStatus}
				</Box>
			),
		},
		{ title: 'Raised By', field: 'raisedBy', align: 'center', width: 150 },
		{
			title: 'Opened Time',
			field: 'defectOpenedTs',
			align: 'center',
			width: 200,
			render: (row) => (
				<Typography sx={{ fontSize: '0.9rem' }}>
					{row.defectOpenedTs
						? new Date(row.defectOpenedTs).toLocaleString()
						: '-'}
				</Typography>
			),
		},
	];

	const autoDefectColumns = [
		{ title: 'ID', field: 'id', align: 'center', width: 100 },
		{
			title: 'Parameter Key',
			field: 'parameterKey',
			align: 'center',
			width: 260,
		},
		{
					title: 'Defect reason',
					field: 'reason',
					align: 'center',
					width: 250,
					render: (row) => (
						<Typography
								sx={{
										display: '-webkit-box',
										WebkitBoxOrient: 'vertical',
										WebkitLineClamp: 3,
										overflow: 'hidden',
										whiteSpace: 'normal',
										overflowWrap: 'break-word',
										wordBreak: 'break-word',
										lineHeight: 1.4,
								}}
						>
								{row.reason}
						</Typography>
					),
				},
		{ title: 'Remark', field: 'remark', align: 'center', width: 300 },
		{
			title: 'Status',
			field: 'defectStatus',
			align: 'center',
			width: 150,
			render: (row) => (
				<Box
					sx={{
						background:
							row.defectStatus === 'CLOSED'
								? 'rgba(76, 175, 80, 0.1)'
								: 'rgba(244, 67, 54, 0.1)',
						color: row.defectStatus === 'CLOSED' ? '#4CAF50' : '#F44336',
						px: 2,
						py: 0.5,
						borderRadius: '20px',
						display: 'inline-block',
						fontWeight: 'bold',
					}}
				>
					{row.defectStatus}
				</Box>
			),
		},
		{ title: 'Raised By', field: 'raisedBy', align: 'center', width: 150 },
		{
			title: 'Opened Time',
			field: 'defectOpenedTs',
			align: 'center',
			width: 200,
			render: (row) => (
				<Typography sx={{ fontSize: '0.9rem' }}>
					{row.defectOpenedTs
						? new Date(row.defectOpenedTs).toLocaleString()
						: '-'}
				</Typography>
			),
		},
	];

	const [columnsState, setColumnsState] = useState(manualDefectColumns);

	useEffect(() => {
		setColumnsState(
			activeDefectTab === 'manual' ? manualDefectColumns : autoDefectColumns,
		);
	}, [activeDefectTab]);

	const visibleColumns = useMemo(
		() => columnsState.filter((col) => !col.hidden),
		[columnsState],
	);

	const sequenceNumber = currentLineItem?.sequenceNumber;

	const activeOpenDefects = useMemo(
		() => (activeDefectTab === 'manual' ? manualOpenDefects : autoOpenDefects),
		[activeDefectTab, manualOpenDefects, autoOpenDefects],
	);

	const activeClosedDefects = useMemo(
		() =>
			activeDefectTab === 'manual'
				? manualClosedDefects
				: autoClosedDefects,
		[activeDefectTab, manualClosedDefects, autoClosedDefects],
	);

	const statusFilteredRows = useMemo(() => {
		if (statusFilter === 'OPEN') return activeOpenDefects;
		if (statusFilter === 'CLOSED') return activeClosedDefects;
		return [...activeOpenDefects, ...activeClosedDefects];
	}, [statusFilter, activeOpenDefects, activeClosedDefects]);

	const statusFilteredTableRows = useMemo(
		() =>
			statusFilteredRows.map((row) => ({
				...row,
				showCheckBox: statusFilter !== 'CLOSED' && row.defectStatus === 'OPEN',
			})),
		[statusFilteredRows, statusFilter],
	);

	const showCheckboxes =
		statusFilteredRows.some((row) => row.defectStatus === 'OPEN');

	return (
		<Box className={styles.wtclPage}>
			{/* Current KSPEC Header */}
			<Box sx={{ mb: 2 }}>
				<StyledTable
					title="Current KSPEC"
					columns={partDetailsColumns}
					rows={partDetailsData}
					forceHeight={scaleValue(100)}
					showFilter={false}
					showColumns={false}
					elevated
				/>
			</Box>

			{/* Main Content Area: Centered Defect Table */}
			<Box sx={{ flex: 1, minHeight: 0, mb: 2 }}>
				<Paper
					elevation={3}
					className={styles.tablePaper}
					sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}
				>
					<TableActionBar
						leftContent={
							<Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
								<Typography
									variant="inherit"
									sx={{
										fontWeight: 600,
										fontSize: `${scaleValue(24)}px`,
										color: themeMode === DARK_MODE ? '#F8F8F8' : '#202020',
									}}
								>
									{`Defect Details (${statusFilteredRows.length})`}
								</Typography>
								{selectedDefectIds.length > 0 && (
									<Box
										sx={{
											px: 1.5,
											py: 0.5,
											borderRadius: '20px',
											backgroundColor:
												themeMode === DARK_MODE
													? 'rgba(144, 202, 249, 0.15)'
													: 'rgba(21, 101, 192, 0.12)',
											color: themeMode === DARK_MODE ? '#90CAF9' : '#1565C0',
											fontWeight: 600,
											fontSize: `${scaleValue(16)}px`,
										}}
									>
										{selectedDefectIds.length} selected
									</Box>
								)}
							</Box>
						}
						showDefactive={!!serialNumber && !!sequenceNumber}
						onDefectClick={() => setIsDefectModalOpen(true)}
						showRefresh={true}
						onRefresh={fetchDefects}
						showFilter={true}
						showColumns={true}
						showExport={false}
						columns={columnsState}
						rows={statusFilteredRows}
						onColumnChange={setColumnsState}
						onFilterChange={(filters) => console.log('Filters:', filters)}
						rightContent={
							<Box sx={{ display: 'flex', gap: 2 }}>
								<TakeOut
									partDetails={{
										serialNumber,
										sequenceNumber: currentLineItem?.sequenceNumber,
									}}
									redirectToNextScreen={redirectToHomeScreen}
									btnStyles={{
										height: `${scaleValue(54)}px !important`,
										minHeight: `${scaleValue(54)}px !important`,
										width: 'max-content !important',
										minWidth: `${scaleValue(180)}px !important`,
										fontSize: `${scaleValue(18)}px !important`,
										background: 'linear-gradient(90deg, #CB1D49 0%, #C71616 100%) !important',
										borderRadius: `${scaleValue(8)}px !important`,
										padding: `${scaleValue(10)}px ${scaleValue(38)}px !important`,
										'& svg': { display: 'none !important' },
									}}
								/>
								<MoveToMr
									partDetails={{
										serialNumber,
										sequenceNumber: currentLineItem?.sequenceNumber,
									}}
									btnStyles={{
										height: `${scaleValue(54)}px !important`,
										minHeight: `${scaleValue(54)}px !important`,
										width: 'max-content !important',
										minWidth: `${scaleValue(180)}px !important`,
										fontSize: `${scaleValue(18)}px !important`,
										borderRadius: `${scaleValue(8)}px !important`,
										padding: `${scaleValue(10)}px ${scaleValue(38)}px !important`,
									}}
								/>
							</Box>
						}
					/>
					<Box
						sx={{
							px: 2,
							pt: 0.5,
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
							gap: 2,
							flexWrap: 'wrap',
						}}
					>
						<Tabs
							value={activeDefectTab}
							onChange={handleTabChange}
							variant="fullWidth"
							TabIndicatorProps={{ style: { display: 'none' } }}
							sx={{
								flex: '1 1 320px',
								minHeight: 48,
								backgroundColor:
									themeMode === DARK_MODE ? 'rgba(255,255,255,0.06)' : 'rgba(13,71,161,0.06)',
								border: `1px solid ${themeMode === DARK_MODE ? 'rgba(255,255,255,0.15)' : 'rgba(21,101,192,0.25)'
									}`,
								borderRadius: 2,
								p: 0.5,
							}}
						>
							<Tab
								disableRipple
								value="manual"
								label={`Manual (${manualOpenDefects.length + manualClosedDefects.length})`}
								sx={{
									textTransform: 'none',
									fontWeight: 1000,
									fontSize: `${scaleValue(16)}px`,
									borderRadius: 2,
									color: themeMode === DARK_MODE ? '#F8F8F8' : '#0F107B',
									'&.Mui-selected': {
										background:
											'linear-gradient(90deg, rgba(6,129,74,0.25) 0%, rgba(16,225,137,0.20) 100%)',
										color: themeMode === DARK_MODE ? '#E6FFEF' : '#06814A',
									},
								}}
							/>
							<Tab
								disableRipple
								value="auto"
								label={`Auto (${autoOpenDefects.length + autoClosedDefects.length})`}
								sx={{
									textTransform: 'none',
									fontWeight: 1000,
									fontSize: `${scaleValue(16)}px`,
									borderRadius: 2,
									color: themeMode === DARK_MODE ? '#F8F8F8' : '#0F107B',
									'&.Mui-selected': {
										background:
											'linear-gradient(90deg, rgba(33,150,243,0.22) 0%, rgba(33,204,225,0.16) 100%)',
										color: themeMode === DARK_MODE ? '#E7F6FF' : '#1565C0',
									},
								}}
							/>
						</Tabs>

						<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
							<Typography sx={{ fontWeight: 900, fontSize: `${scaleValue(16)}px` }}>
								Status
							</Typography>
							<FormControl size="small" sx={{ minWidth: 170 }}>
								<Select
									value={statusFilter}
									onChange={handleStatusFilterChange}
									sx={{
										backgroundColor:
											themeMode === DARK_MODE ? 'rgba(255,255,255,0.06)' : '#F4F8FF',
										borderRadius: 2,
										height: 40,
										'.MuiSelect-select': {
											py: 1,
											fontWeight: 900,
										},
									}}
								>
									<MenuItem value="ALL">All</MenuItem>
									<MenuItem value="OPEN">Open</MenuItem>
									<MenuItem value="CLOSED">Closed</MenuItem>
								</Select>
							</FormControl>
						</Box>
					</Box>

					<Box
						sx={{
							flex: 1,
							minHeight: 0,
							overflow: 'hidden',
							px: 2,
							pb: 1,
							display: 'flex',
							flexDirection: 'column',
							gap: 1,
						}}
					>
						<StyledTable
							columns={visibleColumns}
							rows={statusFilteredTableRows}
							showFilter={false}
							showColumns={false}
							showCheckBox={showCheckboxes}
							selectall={showCheckboxes}
							selectedRows={selectedDefectIds}
							onSelectionChange={(newSelection) =>
								setSelectedDefectIds(newSelection)
							}
							maxHeight="52vh"
							fillHeight
						/>
					</Box>
				</Paper>
			</Box>

			{/* Footer: Close Defect (open defects) + WTCL / Mark WTCL */}
			<Box className={styles.footer}>
				<Grid container alignItems="center" justifyContent="flex-end">
					<Grid
						item
						sx={{
							display: 'flex',
							flexWrap: 'wrap',
							gap: 2,
							alignItems: 'center',
							justifyContent: 'flex-end',
						}}
					>
						{hasOpenDefects && (
							<>
								{selectedDefectIds.length > 0 && (
									<Typography
										sx={{
											color: themeMode === DARK_MODE ? '#90CAF9' : '#1565C0',
											fontWeight: 600,
											fontSize: `${scaleValue(16)}px`,
											mr: { xs: 0, sm: 1 },
										}}
									>
										{selectedDefectIds.length} open defect(s) selected
									</Typography>
								)}
								<GradientButton
									onClick={handleCloseDefect}
									disabled={selectedDefectIds.length === 0}
									gradient="linear-gradient(90deg, #435C42 0%, #619C31 100%)"
									sx={{
										height: 56,
										borderRadius: '12px',
										'&.Mui-disabled': {
											opacity: 0.5,
										},
									}}
								>
									<CheckCircleOutlineIcon sx={{ mr: 1 }} />
									Close Defect
								</GradientButton>
								<GradientButton
									onClick={() => {
										if (isDisplayOverallParamsFalse) {
											handleAutoAuthSubmit();
										} else {
											setAuthModalNotice(null);
											setShowAuthModal(true);
										}
									}}
									gradient="linear-gradient(90deg, #06814A 0%, #10E189 100%)"
									sx={{ height: 56, borderRadius: '12px' }}
								>
									<CheckCircleOutlineIcon sx={{ mr: 1 }} />
									WTCL (Override)
								</GradientButton>
							</>
						)}
						{!hasOpenDefects && (
							<>
								{wtclCheckStatus.active && (
									<Typography
										sx={{
											color: wtclCheckStatus.isError
												? '#D32F2F'
												: themeMode === DARK_MODE
													? '#90CAF9'
													: '#1565C0',
											fontWeight: 700,
											fontSize: `${scaleValue(16)}px`,
											mr: { xs: 0, sm: 1 },
										}}
									>
										{wtclCheckStatus.text}
									</Typography>
								)}
								<GradientButton
									onClick={handleMarkWTCLClick}
									gradient="linear-gradient(90deg, #06814A 0%, #10E189 100%)"
									sx={{ height: 56, borderRadius: '12px' }}
								>
									<CheckCircleOutlineIcon sx={{ mr: 1 }} />
									Mark WTCL
								</GradientButton>
							</>
						)}
					</Grid>
				</Grid>
			</Box>

			{showAuthModal && (
				<ExceptionPopup
					notice={authModalNotice}
					handleClose={() => {
						setShowAuthModal(false);
						setAuthModalNotice(null);
					}}
					handleSubmit={handleAuthSubmit}
				/>
			)}

			<DefectModal
				open={isDefectModalOpen}
				handleClose={() => setIsDefectModalOpen(false)}
				partDetailsRow={[
					{
						serialNumber: serialNumber || '-',
						parentPartNumber:
							currentLineItem?.partNumber || currentLineItem?.vcPartNumber || '-',
						parentPartDescription:
							currentLineItem?.description ||
							currentLineItem?.vcDescription ||
							'-',
					},
				]}
				partDetails={{
					serialNumber: serialNumber || currentLineItem?.serialNumber,
					sequenceNumber: currentLineItem?.sequenceNumber,
				}}
				onDefectCreated={fetchDefects}
			/>

			<CloseDefectModal
				open={isCloseDefectModalOpen}
				onClose={() => setIsCloseDefectModalOpen(false)}
				onSubmit={handleSubmitCloseDefects}
				submitting={closingDefects}
				selectedCount={selectedDefectIds.length}
			/>

			<ModalDialog
				open={showWTCLPrintModal}
				title={showPrintPreview ? 'OK Tag Print Preview' : 'WTCL OK Tag Print'}
				onClose={() => {
					setShowWTCLPrintModal(false);
					setShowPrintPreview(false);
				}}
				modalWidth={scaleValue(720)}
				modalHeight="auto"
			>
				<Box sx={{ p: 3, display: 'flex', flexDirection: 'column', gap: 2 }}>
					{showPrintPreview ? (
						/* ── Preview Mode ── */
						<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
							<Box
								sx={{
									width: '100%',
									backgroundColor: '#fff',
									color: '#000',
									padding: '20px',
									border: '1px solid #ccc',
									borderRadius: '8px',
									display: 'flex',
									flexDirection: 'column',
									gap: 1.5,
									fontFamily: 'monospace',
								}}
							>
								<Typography sx={{ fontSize: '24px', fontWeight: 'bold' }}>
									{isPuneJlr() ? 'PUNE OPERATIONS' : 'PANAPAKKAM OPERATIONS'}
								</Typography>
								<Typography sx={{ fontSize: '18px' }}>INDIA</Typography>

								{/* Barcode mock */}
								<Box sx={{ height: '60px', width: '100%', my: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
									<Box sx={{ width: '80%', height: '40px', background: 'repeating-linear-gradient(90deg, #000, #000 3px, transparent 3px, transparent 6px, #000 6px, #000 8px, transparent 8px, transparent 12px)', mb: 0.5 }} />
									<Typography sx={{ letterSpacing: '2px', fontWeight: 'bold' }}>{wtclPrintForm.vin}</Typography>
								</Box>

								{[
									['FULL VIN :-', wtclPrintForm.vin],
									['ENG NUMBER :-', wtclPrintForm.engineSerialNumber],
									['MODEL :-', wtclPrintForm.model],
									['COLOUR :-', wtclPrintForm.colour],
									['TYPE OF SALE :-', 'SOLD'],
								].map(([label, val]) => (
									<Box key={label} sx={{ display: 'flex' }}>
										<Typography sx={{ width: '180px' }}>{label}</Typography>
										<Typography>{val}</Typography>
									</Box>
								))}

								<Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
									<Box sx={{ display: 'flex' }}>
										<Typography sx={{ width: '180px' }}>MONTH & YEAR :-</Typography>
										<Typography>{wtclPrintForm.monthYear}</Typography>
									</Box>
								</Box>
								<Box sx={{ display: 'flex', mt: 1 }}>
									<Typography sx={{ width: '180px' }}>DISTRIBUTER :-</Typography>
									<Typography>
										{isPuneJlr() ? 'TATA MOTORS LTD.' : 'TATA MOTORS PASSENGER VEHICLES'}
									</Typography>
								</Box>
							</Box>

							<Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 1, width: '100%' }}>
								<Button variant="outlined" onClick={() => setShowPrintPreview(false)}>Back</Button>
								<Button variant="contained" onClick={performActualPrint}>Print</Button>
							</Box>
						</Box>
					) : (
						/* ── Form Mode ── */
						<>
							{printModalInfo ? (
								<Typography
									sx={{
										color: themeMode === DARK_MODE ? '#90CAF9' : '#1565C0',
										fontWeight: 600,
									}}
								>
									{printModalInfo}
								</Typography>
							) : null}
							<TextField
								label="VIN"
								value={wtclPrintForm.vin}
								fullWidth
								disabled
							/>
							<TextField
								label="Engine Serial Number"
								value={wtclPrintForm.engineSerialNumber}
								onChange={(e) =>
									handlePrintFieldChange('engineSerialNumber', e.target.value)
								}
								fullWidth
								disabled={isEngineReadonly}
							/>
							<TextField
								label="Model"
								value={wtclPrintForm.model}
								onChange={(e) => handlePrintFieldChange('model', e.target.value)}
								fullWidth
							/>
							<TextField
								label="Colour"
								value={wtclPrintForm.colour}
								onChange={(e) => handlePrintFieldChange('colour', e.target.value)}
								fullWidth
							/>
							<TextField
								label="Month / Year (MM/YY)"
								value={wtclPrintForm.monthYear}
								onChange={(e) => handlePrintFieldChange('monthYear', e.target.value)}
								fullWidth
							/>

							<Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 1, flexWrap: 'wrap' }}>
								<Button
									variant="outlined"
									onClick={handlePrintFromModal}
								>
									Print
								</Button>
								<Button
									variant="outlined"
									onClick={handlePrintFromModal}
								>
									Retry Print
								</Button>
								<Button
									variant="contained"
									onClick={() => {
										setShowWTCLPrintModal(false);
										setShowPrintPreview(false);
									}}
								>
									Close
								</Button>
							</Box>
						</>
					)}
				</Box>
			</ModalDialog>
		</Box>
	);
};

export default connect(mapStateToProps, mapDispatchToProps)(WTCL);